import { memo, forwardRef, Fragment } from "react";

import { Kbd, Tooltip } from "@bigbinary/neeto-atoms";

import {
  convertHotkeyToUsersPlatform,
  shortenHotKey,
  getTooltipProps,
} from "./utils";

const KbdWithRef = forwardRef(({ children, ...props }, ref) => (
  <span {...{ ref, ...props }}>
    <Kbd className="nv-kbd">{children}</Kbd>
  </span>
));
KbdWithRef.displayName = "KbdWithRef";

const KbdKey = ({ keyName, tooltipProps }) => {
  if (tooltipProps) {
    return (
      <Tooltip content={tooltipProps.content} position="top">
        <KbdWithRef>{keyName}</KbdWithRef>
      </Tooltip>
    );
  }

  return <Kbd className="nv-kbd">{keyName}</Kbd>;
};

const HotKey = ({ description, sequence }) => {
  const hotkey = shortenHotKey(convertHotkeyToUsersPlatform(sequence));
  const isSequentialHotkey = hotkey.includes(" ");
  const isSimultaneousHotkey = hotkey.includes("+");
  const isSingleKeyHotkey = !isSequentialHotkey && !isSimultaneousHotkey;
  let sequences = [];

  if (isSingleKeyHotkey) {
    sequences = [hotkey];
  } else if (isSequentialHotkey) {
    sequences = hotkey.split(" ");
  } else if (isSimultaneousHotkey) {
    sequences = hotkey.split("+");
  }

  return (
    <div className="my-3 w-full">
      <div
        className="flex items-center justify-between gap-3"
        data-testid="hotkey-item"
      >
        <span className="text-foreground min-w-0 flex-grow text-sm leading-normal break-words">
          {description}
        </span>
        <div className="flex flex-shrink-0 items-center gap-1">
          {sequences.map((keyName, idx) => (
            <Fragment key={idx}>
              <KbdKey
                {...{ keyName }}
                tooltipProps={getTooltipProps(keyName)}
              />
              {isSequentialHotkey && idx + 1 !== sequences.length && (
                <KbdKey keyName="then" />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(HotKey);
